import { Component } from '@angular/core';
import { AlertController, IonicPage, NavController, NavParams } from 'ionic-angular';
import { MessageHelper } from '../../providers/helpers/messages';
import { ServiceProvider } from '../../providers/service/service';

@IonicPage()
@Component({
  selector: 'page-matriculas',
  templateUrl: 'matriculas.html',
})
export class MatriculasPage {

  form: any = {
    status: "",
    type: "",
    search: "",
    codigo: "",
    page: 1,
    id_turma: null,
    date_start: "",
    date_end: "",
    forpage: 10
  }

  formModalDesconto: any = {
    codigo: "",
    desconto: 0
  }

  formChangeTurma : any = {
    idTurma: null,
    codigo: null
  }

  resultData: any = null;
  urlSearch = "/matriculas";

  turmas = new Array();
  turmaChangeCheck : any = null;

  public targetModalDesconto: string = "modal-set-desconto";
  public targetModalChangeTurma : string = "modal-change-turma";

  constructor(public navCtrl: NavController, public navParams: NavParams,
    private service: ServiceProvider, private msgHelper: MessageHelper,
    private alertCtrl : AlertController) {
  }

  ionViewWillEnter() {
    this.search();
    this.searchTurmas();
  }

  public search() {
    this.form.page = 1;
    this.getData();
  }

  public backPage() {
    this.form.page = this.form.page - 1;
    this.getData();
  }

  public nextPage() {
    this.form.page = this.form.page + 1;
    this.getData();
  }

  public nextAll() {
    this.form.page = this.resultData.totalPages;
    this.getData();
  }

  public backAll()
  {
    this.search();
  }

  /**
   * Retorna os dados da API
   */
  private getData() {
    this.resultData = null;
    this.service.postData(this.form, this.urlSearch, false).then(result => {
      this.resultData = result;
      console.log(this.resultData);
      if (this.resultData.result == 0) {
        this.resultData = null;
      } else {
        this.resultData = this.resultData.data;
      }
      console.log(this.resultData);
    }, error => {
      this.msgHelper.showAlert("Opps", error.message);
    });
  }

  transformValor(valor : number, withCurrency : boolean = false)
  {
    var numero = valor.toFixed(2).split('.');
    numero[0] =  numero[0].split(/(?=(?:...)*$)/).join('.');
    if (withCurrency){
      return "R$" + numero.join(',');
    }
    return numero.join(',');
  }

  private searchTurmas()
  {
    this.turmas = new Array();
    this.service.postData({status: 1}, "/turmas/list", false).then(result => {
      let resultData : any = result;
      console.log(resultData);
      if (resultData.result == 1){
        this.turmas = resultData.data;
      }
    }, error => {
      this.msgHelper.showAlert("Opps", error.message);
    });
  }

  /**
   * Abre o link da matrícula
   * @param obj any
   */
  openLink(obj : any)
  {
    window.open(obj.link,"_blank");
  }

  setDesconto(obj : any){
    this.formModalDesconto = {
      codigo: obj.codigo,
      desconto: ""
    };
    document.getElementById(this.targetModalDesconto).classList.add("show");
  }

  changeTurma(obj : any){
    this.formChangeTurma.idTurma = null;
    this.formChangeTurma.codigo = obj.codigo;
    this.turmaChangeCheck = null;
    this.turmaChangeCheck = obj.turma.id;
    document.getElementById(this.targetModalChangeTurma).classList.add("show");
  }

  /**
   * Atualiza no banco a turma da matrícual
   */
  saveChangeTurma(){
    if (this.formChangeTurma.idTurma == "" || this.formChangeTurma.idTurma == null) {
      return this.msgHelper.showToast("Você precisa selecionar uma turma", "bottom", 2000);
    }

    this.msgHelper.createLoading('crescent', 'Carregando...');
    this.msgHelper.showLoading();

    this.service.postData(this.formChangeTurma, "/matriculas/change-turma", false).then(result => {
      this.msgHelper.closeLoading();
      let response: any = result;
      if (response.result == 0) {
        return this.msgHelper.showAlert("Atenção!", response.message);
      }
      this.msgHelper.showAlert("Sucesso!", response.message);
      document.getElementById(this.targetModalChangeTurma).classList.remove("show");
      this.search();
    }, error => {
      this.msgHelper.closeLoading();
      this.msgHelper.showAlert("Opps", error.message);
    });
  }

  saveDesconto()
  {
    if (this.formModalDesconto.codigo == "" || this.formModalDesconto.codigo == null) {
      return this.msgHelper.showToast("Você precisa informar o código da matrícula", "bottom", 2000);
    }

    this.msgHelper.createLoading('crescent', 'Carregando...');
    this.msgHelper.showLoading();

    this.service.postData(this.formModalDesconto, "/matriculas/set-desconto", false).then(result => {
      this.msgHelper.closeLoading();
      let response: any = result;
      if (response.result == 0) {
        return this.msgHelper.showAlert("Atenção!", response.message);
      }
      this.msgHelper.showAlert("Sucesso!", response.message);
      document.getElementById(this.targetModalDesconto).classList.remove("show");
      this.search();
    }, error => {
      this.msgHelper.closeLoading();
      this.msgHelper.showAlert("Opps", error.message);
    });
  }

  /**
   * Remove a matrícula do aluno em uma turma especifica
   * @param obj any
   */
  delete(obj : any){
    let alert = this.alertCtrl.create({
      title: 'Atenção',
      message: 'Você deseja mesmo remover a matrícula do usuário?',
      buttons: [
        {
          text: 'Não',
          role: 'cancel',
          handler: () => {}
        },
        {
          text: 'Sim',
          handler: () => {
            this.msgHelper.createLoading('crescent', 'Carregando...');
            this.msgHelper.showLoading();

            this.service.postData({codigo: obj.codigo}, "/matriculas/delete", false).then(result => {
              this.msgHelper.closeLoading();
              let response: any = result;
              if (response.result == 0) {
                return this.msgHelper.showAlert("Atenção!", response.message);
              }
              this.msgHelper.showAlert("Sucesso!", response.message);
              this.search();
            }, error => {
              this.msgHelper.closeLoading();
              this.msgHelper.showAlert("Opps", error.message);
            });
          }
        }
      ]
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/matriculas/matriculas.ts